module.exports = __webpack_public_path__ + "img/services5.jpg?216d97ed188f93ecb32fdfafe694866b";